import React, { useState, useEffect } from "react";
import UserForm from "./form";
import axios from "axios";
import { Box, Button, CircularProgress, Grid, Paper, Backdrop } from "@mui/material";
import PrivateLayout from "layouts/privateLayout";
import BasicBreadcrumbs from "components/breadcrumb";
import Header from "components/header";
import { toast } from "react-toastify";
import { blue } from "@mui/material/colors";
import SuccessAlert from "helper/successAlert";
import ErrorAlert from "helper/errorAlert";
import { useNavigate } from "react-router-dom";
import ButtonComponent from "components/button";
import { useApiClient } from "context/ApiClientContext";

export default function UserProfileIndex() {
  const userId = localStorage.getItem("loggedInID");
  const [loading, setLoading] = useState(false);
  const [currentPassword, setCurrentPassword] = useState();
  const [roleList, setRoleList] = useState([]);
  const navigate = useNavigate();
  const [inputForm, setInputForm] = useState({
    userName: "",
    email: "",
    roleid: "",
    lastcompany: "",
    oldPassword: "",
    password: "",
    confirmPassword: "",
    isActive: false,
  });
  const apiClient = useApiClient();
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const fetchUser = () => {
    axios
      .get(`${apiClient}/user/${userId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      })
      .then((response) => {
        const { id, userName, email, isActive, lastcompany, password, roleid } = response.data;
        const newData = {
          id: id,
          userName: userName,
          email: email,
          isActive: isActive,
          lastcompany: lastcompany,
          password: "",
          roleid: roleid,
          bulkcompanyuser: [],
        };
        setCurrentPassword(password);
        setInputForm(newData);
      })
      .catch((error) => {
        console.error("Error fetching user details:", error);
      });
  };

  const fetchRole = () => {
    axios
      .get(`${apiClient}/role`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      })
      .then((response) => {
        const roleList = response.data;
        setRoleList(roleList);
      })
      .catch((error) => {
        console.error("Error fetching user details:", error);
      });
  };

  useEffect(() => {
    fetchUser();
    fetchRole();
  }, []);

  const handleInputChange = (property, value) => {
    setInputForm((prevState) => ({
      ...prevState,
      [property]: value,
    }));
  };

  const handleSubmit = async () => {
    const toastId = toast.loading("Saving data...", {
      position: "top-right",
    });

    try {
      setOpenBackdrop(true);
      await new Promise((resolve) => setTimeout(resolve, 3000));

      let response = "";
      setLoading(true);
      inputForm.password = currentPassword;

      response = await axios.put(
        `${apiClient}/user/${userId}`,
        inputForm,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            Accept: "application/json",
          },
        }
      );

      toast.update(toastId, {
        render: "Successfully updated.",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });

      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (error) {
      toast.update(toastId, {
        render: error,
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setLoading(false);
      setOpenBackdrop(false);
    }
  };

  return (
    <PrivateLayout>
      <Box sx={{ width: "100%", marginTop: "10px" }}>
        <BasicBreadcrumbs first="User" second="Details" />
        <Box display="flex" justifyContent="space-between" alignItems="center" px={3}>
          <Header title="User Profile Details" />
        </Box>
        <Paper>
          <Grid container spacing={2} p={3} mt={1} display="flex" justifyContent="start">
            <Grid item xs={12} xl={8}>
              <UserForm
                id={userId}
                inputForm={inputForm}
                roleList={roleList}
                handleInputChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} xl={8} display="flex" justifyContent="end">
              <ButtonComponent value="contained" text="Save" callback={handleSubmit} />
              {loading && (
                <CircularProgress color="inherit" />
              )}
            </Grid>
          </Grid>
        </Paper>
      </Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </PrivateLayout>
  );
}
